/**
 * ============================================================
 * PGLP | MONTE HERMOM
 * CONFIG: expediente
 * ============================================================
 */

export const expedientePadrao = {
  inicio: '08:00',
  fim:    '18:00',
  intervalos: [
    { inicio: '12:00', fim: '13:00' },
  ],
};

export const expedienteForense = {
  inicio: '09:00',
  fim:    '17:00',
  intervalos: [],
};

export const expedienteEstendido = {
  inicio: '08:00',
  fim:    '20:00',
  intervalos: [
    { inicio: '12:00', fim: '13:00' },
    { inicio: '18:00', fim: '18:30' },
  ],
};

export const EXPEDIENTES = {
  PADRAO:    expedientePadrao,
  FORENSE:   expedienteForense,
  ESTENDIDO: expedienteEstendido,
};

export function obterExpediente(nome) {
  return EXPEDIENTES[String(nome || '').toUpperCase()] || expedientePadrao;
}

export default {
  expedientePadrao,
  expedienteForense,
  expedienteEstendido,
  EXPEDIENTES,
  obterExpediente,
};